module.exports = __webpack_public_path__ + "rw-widgets.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.svg?v=4.1.0
// module id = 794
// module chunks = 0